import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import { stateChange } from "../functions/stateChange";
import "../styles/Admin.css";
import { useState } from "react";
import Swal from "sweetalert2";
import { LoadModel } from "../functions/LoadModel";
import { fetchData } from "../store/actions/handleMagazzino";
import { errorReset } from "../store/actions/handleHome";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Spinner from "../components/Spinner";

function Admin() {
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email");
  const dispatch = useDispatch();

  const listGrattaArr = useSelector((state) => state.magazzinoReducers.listGrattaArr);

  let arrGratta = [];
  for (const key in listGrattaArr) {
    arrGratta = arrGratta.concat(listGrattaArr[key]);
  }

  console.log(arrGratta);
  const loading = useSelector((state) => state.magazzinoReducers.loading);
  const [formData, setFormData] = useState({
    nome: "",
    codiceGratta: 0,
    imgC: "",
    imgM: "",
    vUnita: 0,
    nUnita: 0,
  });

  const [activeForm, setActiveForm] = useState("existing");
  const [newGrattaFormData, setNewGrattaFormData] = useState({
    nome: "",
    codiceGratta: 0,
    imgC: "",
    imgM: "",
    vUnita: 0,
    nUnita: 0,
  });

  useEffect(() => {
    if (token && email === "salvo.lorello@gmail.com") {
      stateChange();
      dispatch(errorReset());
      dispatch(fetchData());

      const event = new Event("userAuthStateChanged");
      window.dispatchEvent(event);

      const currentEmail = localStorage.getItem("email");
      localStorage.setItem("_tempEmail", currentEmail);
      localStorage.removeItem("_tempEmail");
    }
  }, [dispatch, email, token]);

  if (!token || email !== "salvo.lorello@gmail.com") {
    return <Redirect to="/"></Redirect>;
  }
  const submitForm = async (e) => {
    e.preventDefault();
    if (formData.nome.trim() === "") {
      Swal.fire({
        title: "Errore",
        text: "il campo 'nome' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (formData.codiceGratta === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'codiceGratta' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (formData.imgC.trim() === "") {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Immagine' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (formData.nUnita === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Numero unità' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (formData.vUnita === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Valore unità' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    const result = await LoadModel(formData);
    console.log(result);

    if (!result) {
      Swal.fire({
        title: "Errore",
        text: "Modello non caricato",
        icon: "warning",
      });
      setFormData({
        nome: "",
        codiceGratta: 0,
        imgC: "",
        imgM: "",
        vUnita: 0,
        nUnita: 0,
      });
      return;
    }
    Swal.fire({
      title: "Succes",
      text: "Modello caricato",
      icon: "Success",
    });
    setFormData({ nome: "", codiceGratta: 0, imgC: "", imgM: "", vUnita: 0, nUnita: 0 });
  };

  const submitNewGrattaForm = async (e) => {
    e.preventDefault();
    if (newGrattaFormData.nome.trim() === "") {
      Swal.fire({
        title: "Errore",
        text: "il campo 'nome' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (newGrattaFormData.codiceGratta === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'codiceGratta' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (newGrattaFormData.imgC.trim() === "") {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Immagine Coperta' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (newGrattaFormData.imgM.trim() === "") {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Immagine Mostrata' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (newGrattaFormData.nUnita === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Numero unità' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }
    if (newGrattaFormData.vUnita === 0) {
      Swal.fire({
        title: "Errore",
        text: "il campo 'Valore unità' è vuoto o non valido",
        icon: "warning",
      });
      return;
    }

    const result = await LoadModel(newGrattaFormData);
    console.log(result);

    if (!result) {
      Swal.fire({
        title: "Errore",
        text: "Modello non caricato",
        icon: "warning",
      });
      return;
    }
    Swal.fire({
      title: "Succes",
      text: "Nuovo Gratta e Vinci caricato",
      icon: "success",
    });
    setNewGrattaFormData({
      nome: "",
      codiceGratta: 0,
      imgC: "",
      imgM: "",
      vUnita: 0,
      nUnita: 0,
    });
  };

  const rednerSelectName = () => {
    return arrGratta.map((item) => {
      return <option value={item.nome}>{item.nome}</option>;
    });
  };
  const rednerSelectImg = () => {
    return arrGratta.map((item) => {
      return <option value={item.imgM}>{item.nome}</option>;
    });
  };

  return loading ? (
    <Spinner />
  ) : (
    <div class="local-bootstrap">
      <div className="admin">
        <div className="admin-header">
          <Link to="/" className="back-to-home-btn">
            <button className="btn btn-warning">← Torna alla Home</button>
          </Link>
        </div>

        <div className="form-toggle-buttons mb-4">
          <button
            className={`btn ${activeForm === "existing" ? "btn-primary" : "btn-outline-primary"} me-2`}
            onClick={() => setActiveForm("existing")}
          >
            Inserisci Gratta e Vinci Esistente
          </button>
          <button
            className={`btn ${activeForm === "new" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setActiveForm("new")}
          >
            Crea Nuovo Gratta e Vinci
          </button>
        </div>

        {activeForm === "existing" ? (
          <form className="form-admin">
            <h2 className="admin-section-title">Inserimento Gratta e Vinci Esistente</h2>
            <div class="form-group mt-2">
              <label for="nome-select">Seleziona il Nome</label>
              <select
                class="form-select"
                aria-label="Disabled select example"
                id="nome-select"
                onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              >
                <option selected>SELEZIONA IL NOME</option>
                {rednerSelectName()}
              </select>
            </div>
            <div class="form-group mt-3">
              <label for="codice-gratta">Codice Gratta&Vinci</label>
              <input
                type="number"
                class="form-control"
                id="codice-gratta"
                name="codiceGratta"
                placeholder="Codice Gratta&Vinci"
                value={formData.codiceGratta}
                onChange={(e) => setFormData({ ...formData, codiceGratta: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="img-gratta">Immagine Gratta&Vinci</label>

              <select
                class="form-select"
                aria-label="Disabled select example"
                id="img-gratta"
                onChange={(e) => setFormData({ ...formData, imgC: e.target.value })}
              >
                <option selected>SELEZIONA L'IMMAGINE</option>
                {rednerSelectImg()}
              </select>
            </div>
            <div class="form-group mt-3">
              <label for="n-unita">Numero Unità</label>
              <input
                type="number"
                class="form-control"
                id="n-unita"
                name="nUnita"
                placeholder="Numero Unità"
                value={formData.nUnita}
                onChange={(e) => setFormData({ ...formData, nUnita: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="v-unita">Valore Unità</label>
              <input
                type="number"
                class="form-control"
                id="v-unita"
                name="vUnita"
                placeholder="0"
                value={formData.vUnita}
                onChange={(e) => setFormData({ ...formData, vUnita: e.target.value })}
              />
            </div>
            <div className="btn-container">
              <button type="submit" class="btn btn-primary" onClick={submitForm}>
                Carica Gratta e Vinci
              </button>
            </div>
          </form>
        ) : (
          <form className="form-admin">
            <h2 className="admin-section-title">Creazione Nuovo Gratta e Vinci</h2>
            <div class="form-group mt-3">
              <label for="nuovo-nome">Nome Gratta e Vinci</label>
              <input
                type="text"
                class="form-control"
                id="nuovo-nome"
                name="nome"
                placeholder="Nome Gratta e Vinci"
                value={newGrattaFormData.nome}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, nome: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="nuovo-codice-gratta">Codice Gratta&Vinci</label>
              <input
                type="number"
                class="form-control"
                id="nuovo-codice-gratta"
                name="codiceGratta"
                placeholder="Codice Gratta&Vinci"
                value={newGrattaFormData.codiceGratta}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, codiceGratta: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="nuovo-imgC">Immagine Coperta (URL)</label>
              <input
                type="text"
                class="form-control"
                id="nuovo-imgC"
                name="imgC"
                placeholder="URL immagine coperta"
                value={newGrattaFormData.imgC}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, imgC: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="nuovo-imgM">Immagine Mostrata (URL)</label>
              <input
                type="text"
                class="form-control"
                id="nuovo-imgM"
                name="imgM"
                placeholder="URL immagine mostrata"
                value={newGrattaFormData.imgM}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, imgM: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="nuovo-n-unita">Numero Unità</label>
              <input
                type="number"
                class="form-control"
                id="nuovo-n-unita"
                name="nUnita"
                placeholder="Numero Unità"
                value={newGrattaFormData.nUnita}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, nUnita: e.target.value })}
              />
            </div>
            <div class="form-group mt-3">
              <label for="nuovo-v-unita">Valore Unità</label>
              <input
                type="number"
                class="form-control"
                id="nuovo-v-unita"
                name="vUnita"
                placeholder="0"
                value={newGrattaFormData.vUnita}
                onChange={(e) => setNewGrattaFormData({ ...newGrattaFormData, vUnita: e.target.value })}
              />
            </div>
            <div className="btn-container">
              <button type="submit" class="btn btn-success" onClick={submitNewGrattaForm}>
                Crea Nuovo Gratta e Vinci
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default Admin;
